import React, { useEffect } from "react";
import { useParams } from "react-router-dom";
import useFileDocuments from "../actions/useFileDocuments";
import SearchFIles from "./SearchFIles";
import {
  handleDisableFilter,
  setBlobFilterStates,
} from "~/Pages/Process/actions/attachmentsSlice";
import { useDispatch, useSelector } from "react-redux";
import FolderListSection from "~/components/folder-list-section/FolderListSection";

const RequestTypeFileDocuments = () => {
  const { id, service_id, type, request_type } = useParams();
  const { blobFilterStates } = useSelector((state) => state.attachments);
  const dispatch = useDispatch();
  const {
    states,
    fileName,
    setFileName,
    rows,
    first,
    onPageChange,
    handleClickRequest,
  } = useFileDocuments({ id, service_id, type, request_type });
  useEffect(() => {
    dispatch(setBlobFilterStates({}));
  }, []);
  useEffect(() => {
    if (states.folders) {
      dispatch(handleDisableFilter(!states.folders?.length));
    }
  }, [states.folders]);
  return (
    <FolderListSection
      folders={states?.folders}
      loading={states.loading}
      isFilterApplied={!!blobFilterStates?.selectedItems?.length}
      onFolderClick={handleClickRequest}
      showEmptyState={true}
      filterContent={
        <SearchFIles
          fileName={fileName}
          setFileName={setFileName}
          additionaltag={{ entity: [states?.entity_detail?.name] }}
          states={states}
          first={first}
          rows={rows}
          onPageChange={onPageChange}
          isRootFolder={true}
        />
      }
    />
  );
};

export default RequestTypeFileDocuments;
